import UserService from "@/services/UserService.js";
import moment from "moment";
import { apiClient } from "@/services/ApiClient";

export const namespaced = true;

const LONG_DATE = "D MMM YYYY, h:mm A";

export const state = {
  users: [],
  user: {},
  me: {},
  is_logged_in: false,
  is_admin: false,
  folders: []
};

export const mutations = {
  SET_USERS(state, users) {
    users.map(user => {
      user.created_at = moment(user.created_at).format(LONG_DATE);
    });
    state.users = users;
  },
  ADD_USER(state, new_user) {
    new_user.created_at = moment(new_user.created_at).format(LONG_DATE);
    state.users.unshift(new_user);
  },
  EDIT_USER(state, user) {
    state.user = user;
  },
  SAVE_USER(state, user) {
    _.remove(state.users, function (u) {
      return u.id == user.id;
    });
    state.users.unshift(user);
  },
  SET_ME(state, user) {
    state.me = user;
    state.is_logged_in = true;

    localStorage.setItem("user", JSON.stringify(user));
    let logged_in_user = JSON.parse(JSON.stringify(user));
    apiClient.defaults.headers.common["x-auth"] = logged_in_user.auth;

    if (logged_in_user.account_type == "admin") {
      state.is_admin = true;
    }
  },
  SET_FOLDERS(state, folders = []) {
    state.folders = folders;
  },
};

export const actions = {
  list({ commit, dispatch }) {
    dispatch("setIsLoading", true, { root: true });
    return UserService.list().then(response => {
      dispatch("setIsLoading", false, { root: true });
      commit("SET_USERS", response.data);
    });
  },
  delete({ commit, dispatch }, { id }) {
    dispatch("setIsLoading", true, { root: true });
    return UserService.delete(id).then(response => {
      dispatch("setIsLoading", false, { root: true });
    });
  },
  add({ commit, dispatch }, user) {
    dispatch("setIsLoading", true, { root: true });
    return UserService.add(user).then(response => {
      dispatch("setIsLoading", false, { root: true });
      let saved_user = response.data;
      saved_user.token = user.token;
      commit("ADD_USER", saved_user);
    });
  },
  edit({ commit, dispatch }, user) {
    user.timestamp = new Date();
    let clone = JSON.parse(JSON.stringify(user));
    clone.pwd = ""; // pwd cannot be edited, but can be overwritten as new pwd
    commit("EDIT_USER", clone);
  },
  save({ commit, dispatch }, user) {
    dispatch("setIsLoading", true, { root: true });
    return UserService.save(user).then(() => {
      dispatch("setIsLoading", false, { root: true });
      commit("SAVE_USER", user);
    });
  },
  login({ commit, dispatch }, { email, password }) {
    // email is used as username
    dispatch("setIsLoading", true, { root: true });
    return UserService.login(email, password).then(response => {
      let user = response.data;
      commit("SET_ME", user);

      dispatch('monday/get_me', null, { root: true }).then((response) => {
        user.monday_me = response.data.data.me;
        dispatch("setIsLoading", false, { root: true });
        commit("SET_ME", user);
      })
    })
  },
  logout({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem("user");
      delete apiClient.defaults.headers.common["x-auth"];
      state.is_logged_in = false;
      state.is_admin = false;
      resolve();
    });
  },
  set({ commit, dispatch }, user) {
    commit("SET_ME", user);
  },
  // user folders
  save_folders({ commit, dispatch }, folders) {
    dispatch("setIsLoading", true, { root: true });
    return UserService.saveFolders(folders).then(() => {
      dispatch("setIsLoading", false, { root: true });
      commit("SET_FOLDERS", folders);
    });
  },
  get_folders({ commit, dispatch }) {
    return UserService.getFolders().then((response) => {
      let folders = response.data;
      commit("SET_FOLDERS", folders);
    });
  },
};
